export function PageHeader({ eyebrow, title, desc, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end gap-4 justify-between mb-8">
      <div>
        {eyebrow && <p className="text-[11px] uppercase tracking-[0.25em] text-brand font-semibold">{eyebrow}</p>}
        <h1 className="font-display text-4xl sm:text-5xl font-semibold mt-1">{title}</h1>
        {desc && <p className="text-sm text-anthracite/55 mt-2 max-w-2xl">{desc}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function Panel({ title, children, className = "", actions, testid }) {
  return (
    <section className={`rounded-2xl border border-border-subtle bg-white p-5 sm:p-6 ${className}`} data-testid={testid}>
      {(title || actions) && (
        <div className="flex items-center justify-between gap-3 mb-4">
          {title && <h2 className="text-base font-semibold">{title}</h2>}
          {actions}
        </div>
      )}
      {children}
    </section>
  );
}

export function Btn({ variant = "primary", className = "", ...props }) {
  const v = {
    primary: "bg-brand text-white hover:bg-brand-hover",
    ghost: "border border-border-subtle bg-white hover:bg-accent-subtle",
    danger: "border border-red-200 bg-white text-red-700 hover:bg-red-50",
  }[variant];
  return <button {...props} className={`inline-flex items-center justify-center gap-2 rounded-full px-4 h-10 text-sm font-semibold transition-colors disabled:opacity-50 ${v} ${className}`} />;
}

export function Badge({ tone = "neutral", children, testid }) {
  const t = {
    neutral: "bg-accent-subtle text-anthracite/70", green: "bg-emerald-50 text-emerald-700",
    red: "bg-red-50 text-red-700", amber: "bg-amber-50 text-amber-800", blue: "bg-sky-50 text-sky-700",
  }[tone];
  return <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${t}`} data-testid={testid}>{children}</span>;
}

export const inputCls = "w-full h-11 rounded-xl border border-border-subtle bg-white px-3 text-sm outline-none focus:border-brand focus:ring-2 focus:ring-brand/15";
